import React from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import clsx from 'clsx';
import './index.css';

export const MultiBadgeSelect = ({
  label,
  type,
  color,
  value,
  values,
  onChange,
}) => {
  const onChangeValue = (key) => {
    const arr = [...(value || [])];
    const posKey = arr.findIndex((v) => v === key);
    if (posKey >= 0) {
      arr.splice(posKey, 1);
    } else {
      arr.push(key);
    }

    onChange(arr);
  };

  return (
    <>
      <div className={'px-4'}>
        <Label
          {...label}
          align='text-center'
          size='4xl'
        />
      </div>
      <div
        className={clsx(
          'mt-8',
          'md:justify-center',
          'flex-1',
          // 'flex flex-col items-center space-y-4',
          ' grid grid-cols-1 md:grid-cols-2 gap-3'
        )}>
        {values.map((v, key) => {
          const active = value?.includes(v.value);
          const opacity = value?.length > 0 && !active ? 'opacity-50' : null;

          return (
            <div
              key={key}
              className={clsx('flex w-full', opacity)}>
              <div
                key={key}
                className={clsx(
                  'multi-badge',
                  'w-full',
                  'group flex flex-row items-center cursor-pointer',
                  'px-4 py-3 rounded-full',
                  'space-x-4',
                  'border',
                  'rounded-xl',
                  {
                    'bg-white': !value || value?.length === 0,
                    'bg-black': active,
                  }
                )}
                onClick={() => onChangeValue(v.value)}>
                <div
                  className={'h-6 w-6 rounded-full border'}
                  style={{ background: v?.color?.hex }}
                />

                <div className={'flex space-x-2'}>
                  <Label
                    text={v?.label?.text}
                    weight={'bold'}
                    color={active ? { classname: 'white' } : undefined}
                  />
                  {v?.subLabel ? (
                    <>
                      <Label
                        text={'|'}
                        color={active ? { classname: 'white' } : undefined}
                      />
                      <Label
                        text={v?.subLabel.text}
                        color={active ? { classname: 'white' } : undefined}
                      />
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
